import ProfileSelector from "@/fragments/forms/profile-selector/ProfileSelector.vue";
import MapForm from "@/fragments/forms/map-form/MapForm";
import TopMenu from "./components/top-menu/TopMenu";
import resolver from "@/support/routes-resolver";
import Footer from "@/fragments/footer/Footer";
import appConfig from "@/config/app-config";
import utils from "@/support/utils";
import sidearImage from "../../assets/img/MicrosoftTeams-image.png";
import MenuClose from "../../assets/img/menu-close.svg";

export default {
  data() {
    return {
      sidearImage,
      MenuClose,
      clipped: false,
      drawer: true,
      right: false,
      fixed: false,
      menuItems: [],
      subMenuOpen: [],
      activeTab: "0",
      panel: 0,
      hotspotMap:window.location.origin + '/hotspotMap'
    };
  },
  computed: {
    isSideBarOpen: {
      get() {
        return (
          this.$store.getters.isSidebarVisible && !this.$store.getters.embed
        );
      },
      set(open) {
        this.$store.commit("setLeftSideBarIsOpen", open);
        // If the side bar is closed by a user's action, then
        // we can set the sidebar pined status as false
        if (open === false) {
          this.$store.commit("setLeftSideBarIsPinned", open);
          // Close mobile virtual keyboard if it was open
          // utils.hideMobileKeyboard()
        }
      }
    },
    homeUrl() {
      const url = resolver.homeUrl();
      return url;
    },
    sidebarContentHeightFormula() {
      const formula = `calc(100% - ${this.$store.getters.sidebarHeaderHeight}px)`;
      return formula;
    }
  },
  methods: {
    getConfigVal(key) {
      let configVal = appConfig[key];
      return configVal;
    },
    readMore() {
      this.$router.push('/termAndCondition');
      var dots = document.getElementById("dots");
      var moreText = document.getElementById("more");
      var btnText = document.getElementById("myBtn");
      var termsCondition = document.getElementById("terms-condition");

      if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
        termsCondition.style.display = "inline";
      } else {
        dots.style.display = "none";
        btnText.innerHTML = "<b>Read less</b>";
        moreText.style.display = "inline";
        termsCondition.style.display = "none";
      }
    },
    menuclose() {
      this.$gtag.event("menu_close_click", {
        event_category: "menu",
        event_label: "Menu close clicks",
        value: "menu_close_click"
      });
      this.$store.commit("setLeftSideBarIsOpen", false);
      this.eventBus.$emit("inputPlaceshow");
      this.eventBus.$emit("buttonstoggleshow");
      this.eventBus.$emit("startingPlace", "");
      this.eventBus.$emit("destinationPlace", "");
    },
    count_about_clicks() {
      this.$gtag.event("about_click", {
        event_category: "menu",
        event_label: "About info clicks",
        value: "about_click"
      });
    },
    count_contribute_clicks() {
      this.$gtag.event("contribute_click", {
        event_category: "menu",
        event_label: "Contribute info clicks",
        value: "contribute_click"
      });
    },
    count_support_clicks() {
      this.$gtag.event("support_click", {
        event_category: "menu",
        event_label: "Support info clicks",
        value: "support_click"
      });
    },
    count_terms_conditions_clicks() {
      this.$gtag.event("terms_conditions_click", {
        event_category: "menu",
        event_label: "Terms and conditions info clicks",
        value: "terms_conditions_click"
      });
    },
    count_bikeable_clicks() {
      this.$gtag.event("bikeable_click", {
        event_category: "menu",
        event_label: "Bikeable visits",
        value: "bikeable_click"
      });
    },
    count_perception_poll_clicks() {
      this.$gtag.event("perception_poll_click", {
        event_category: "menu",
        event_label: "Perception pool visits",
        value: "perception_polle_click"
      });
    },
    count_hotspot_map_clicks() {
      this.$gtag.event("hotspot_map_click", {
        event_category: "menu",
        event_label: "Hotspot map visits",
        value: "hotspot_map_click"
      });
    },
    perceptionPollModal () {
      this.eventBus.$emit('perceptionPollModal')
      this.$store.commit("setLeftSideBarIsOpen", false);
    },
    hotspotMapLink () {
      this.eventBus.$emit('hotspotMapLink')
    }
  },
  watch: {
    "$store.getters.mainMenu": {
      handler: function() {
        this.menuItems = this.$store.getters.mainMenu;
      },
      deep: true
    }
  },
  created() {
    this.menuItems = this.$store.getters.mainMenu;
    /**
     * Set sidebar open status
     */
    const context = this;
    this.eventBus.$on("setSidebarStatus", isOpen => {
      // pass a boolean that indicates 'force'
      context.$store.commit("setLeftSideBarIsOpen", isOpen);
    });
  },
  components: {
    ProfileSelector,
    MapForm,
    appFooter: Footer,
    TopMenu
  }
};
